import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './components/homepage/homepage.component';
import { StructureComponent } from './components/structure/structure.component';
import { InstructionsComponent } from './components/instructions/instructions.component';

const routes: Routes = [
  // {path: '', redirectTo: '/homepage', pathMatch: 'full'},
  { path: '', component: HomepageComponent },
  { path: 'structure', component: StructureComponent },
  { path: 'instructions', component: InstructionsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
